import { render, staticRenderFns } from "./dui-social-links.vue?vue&type=template&id=de52b974&scoped=true&"
import script from "./dui-social-links.vue?vue&type=script&lang=js&"
export * from "./dui-social-links.vue?vue&type=script&lang=js&"
import style0 from "./dui-social-links.vue?vue&type=style&index=0&id=de52b974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de52b974",
  null
  
)

export default component.exports